// 配置路由相关信息
import VueRouter from 'vue-router'
import Vue from 'vue'
import store from '../store/index'
import storage from '../utils/storage'

const Login = () => import('../views/Login.vue')
const QyLogin = () => import('../views/QyLogin.vue')
const Guide = () => import('../views/Guide.vue')
const Home = () => import('../views/Home.vue')
const Mine = () => import('../views/Mine.vue')
const BusinessCenter = () => import('../views/BusinessCenter.vue')
const PasswordFind = () => import('../views/Password_find.vue')
const Register = () => import('../views/register.vue')
const Qrcode = () => import('../views/Qrcode.vue')

// 安装插件
Vue.use(VueRouter)

// 创建VueRouter对象
const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/mine',
        name: 'mine',
        component: Mine,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/businessCenter',
        name: 'businessCenter',
        component: BusinessCenter,
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/Qrcode',
        name: 'qrcode',
        component: Qrcode,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
            showNav: true,
        }
    },
    {
        path: '/warehousIndex',
        name: 'warehousIndex',
        redirect: '/warehousIndex/wManageIndex',
        component: () => import('../views/warehousingManage/warehousIndex.vue'),
        children: [
            {
                path: 'wManageIndex',
                name: 'wManageIndex',
                component: () => import('../views/warehousingManage/index.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'wManageDetail',
                name: 'wManageDetail',
                component: () => import('../views/warehousingManage/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'wManageSettingList/:keyword',
                name: 'wManageSettingList',
                component: () => import('../views/warehousingManage/settingList.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'wManageSettingItem',
                name: 'wManageSettingItem',
                component: () => import('../views/warehousingManage/settingItem.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true
                }
            }
        ],
    },
    {
        path: '/recordIndex',
        name: 'recordIndex',
        redirect: '/recordIndex/wRecordIndex',
        component: () => import('../views/warehousingRecord/RecordIndex.vue'),
        children: [
            {
                path: 'wRecordIndex',
                name: 'wRecordIndex',
                component: () => import('../views/warehousingRecord/index.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'wRecordList/:keyword',
                name: 'wRecordList',
                component: () => import('../views/warehousingRecord/list.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'wRecordDetail',
                name: 'wRecordDetail',
                component: () => import('../views/warehousingRecord/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
        ],
    },
    {
        path: '/commondityIndex',
        name: 'commondityIndex',
        redirect: '/commondityIndex/cManageIndex',
        component: () => import('../views/commondityManage/CommondityIndex.vue'),
        children: [
            {
                path: 'cManageIndex',
                name: 'cManageIndex',
                component: () => import('../views/commondityManage/index.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'addCommondity',
                name: 'addCommondity',
                component: () => import('../views/commondityManage/addCommondity.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'cManageDetail',
                name: 'cManageDetail',
                component: () => import('../views/commondityManage/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'cManageEdit',
                name: 'cManageEdit',
                redirect: '/commondityIndex/cManageEdit/cBaseinfo',
                component: () => import('../views/commondityManage/editCommondity/CommondityEditIndex.vue'),
                children: [
                    {
                        path: 'cBaseinfo',
                        name: 'cBaseinfo',
                        component: () => import('../views/commondityManage/editCommondity/baseInfo.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cImages',
                        name: 'cImages',
                        component: () => import('../views/commondityManage/editCommondity/images.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cSalesParams',
                        name: 'cSalesParams',
                        component: () => import('../views/commondityManage/editCommondity/salesParams.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cAttrLabel',
                        name: 'cAttrLabel',
                        component: () => import('../views/commondityManage/editCommondity/attrLabel.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cAttrLabelSet',
                        name: 'cAttrLabelSet',
                        component: () => import('../views/commondityManage/editCommondity/attrLabelSet.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cShopAttachment',
                        name: 'cShopAttachment',
                        component: () => import('../views/commondityManage/editCommondity/shopAttachment.vue'),
                        meta: {
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cShopAttachmentSet',
                        name: 'cShopAttachmentSet',
                        component: () => import('../views/commondityManage/editCommondity/shopAttachmentSet.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cLabel',
                        name: 'cLabel',
                        component: () => import('../views/commondityManage/editCommondity/commondityLabel.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cDetail',
                        name: 'cDetail',
                        component: () => import('../views/commondityManage/editCommondity/detail.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cIntroDetail/:id',
                        name: 'cIntroDetail',
                        component: () => import('../views/commondityManage/editCommondity/introDetail.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cIntroDetailSet/:cmid',
                        name: 'cIntroDetailSet',
                        component: () => import('../views/commondityManage/editCommondity/introDetailSet.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cOthers',
                        name: 'cOthers',
                        component: () => import('../views/commondityManage/editCommondity/others.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cMultiPrice',
                        name: 'cMultiPrice',
                        component: () => import('../views/commondityManage/editCommondity/multiPrice.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cProductionCode',
                        name: 'cProductionCode',
                        component: () => import('../views/commondityManage/editCommondity/productionCode.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cProductionCodeSet',
                        name: 'cProductionCodeSet',
                        component: () => import('../views/commondityManage/editCommondity/productionCodeSet.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'cProductionCodeDetail',
                        name: 'cProductionCodeDetail',
                        component: () => import('../views/commondityManage/editCommondity/productionCodeDetail.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    }
                ]
            },
            {
                path: 'logsticsIndex',
                name: 'logsticsIndex',
                redirect: '/commondityIndex/logsticsIndex/addRule',
                component: () => import('../views/commondityManage/logisticsRule/LogsticsIndex.vue'),
                children: [
                    {
                        path: 'addRule',
                        name: 'addRule',
                        component: () => import('../views/commondityManage/logisticsRule/addRule.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    },
                    {
                        path: 'addRulePf',
                        name: 'addRulePf',
                        component: () => import('../views/commondityManage/logisticsRule/addRulePf.vue'),
                        meta: {
                            showNav: true,
                            requireAuth: true,
                        }
                    }
                ]
            }
        ],
    },
    {
        path: '/brandIndex',
        name: 'brandIndex',
        component: () => import('../views/brandManage/BrandIndex.vue'),
        redirect: '/brandIndex/brandList',
        children: [
            {
                path: 'brandList',
                name: 'brandList',
                component: () => import('../views/brandManage/list.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'brandDetail',
                name: 'brandDetail',
                component: () => import('../views/brandManage/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            }
        ],
    },
    {
        path: '/supplierIndex',
        name: 'supplierIndex',
        component: () => import('../views/supplierManage/SupplierIndex.vue'),
        redirect: '/supplierIndex/supplierList',
        children: [
            {
                path: 'supplierList',
                name: 'supplierList',
                component: () => import('../views/supplierManage/list.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'supplierDetail',
                name: 'supplierDetail',
                component: () => import('../views/supplierManage/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            }
        ],
    },
    {
        path: '/purchaseIndex',
        name: 'purchaseIndex',
        component: () => import('../views/purchaseManage/PurchaseIndex.vue'),
        redirect: '/purchaseIndex/pManageIndex',
        children: [
            {
                path: 'pManageIndex',
                name: 'pManageIndex',
                component: () => import('../views/purchaseManage/index.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'pManageList/:keyword',
                name: 'pManageList',
                component: () => import('../views/purchaseManage/list.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'pManageDetail',
                name: 'pManageDetail',
                component: () => import('../views/purchaseManage/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'pManageSet',
                name: 'pManageSet',
                component: () => import('../views/purchaseManage/setttingItem.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'pWareList/:id',
                name: 'pWareList',
                component: () => import('../views/purchaseManage/pWareList.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'pWareItem/:id',
                name: 'pWareItem',
                component: () => import('../views/purchaseManage/pWareItem.vue'),
                meta: {
                    requireAuth: true,
                }
            }
        ],
    },
    {
        path: '/storageIndex',
        name: 'storageIndex',
        component: () => import('../views/storageManage/StorageIndex.vue'),
        redirect: '/storageIndex/sManageIndex',
        children: [
            {
                path: 'sManageIndex',
                name: 'sManageIndex',
                component: () => import('../views/storageManage/index.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'sManageTwo',
                name: 'sManageTwo',
                component: () => import('../views/storageManage/two.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'sManageThree',
                name: 'sManageThree',
                component: () => import('../views/storageManage/three.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'sManageFour',
                name: 'sManageFour',
                component: () => import('../views/storageManage/four.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            }
        ],
    },
    {
        path: '/companyIndex',
        name: 'companyIndex',
        component: () => import('../views/companyManage/CompanyIndex.vue'),
        redirect: '/companyIndex/companyManageDetail',
        children: [
            {
                path: 'companyManageDetail',
                name: 'companyManageDetail',
                component: () => import('../views/companyManage/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'companyEdit',
                name: 'companyEdit',
                component: () => import('../views/companyManage/edit.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'companyDetail/:qyid',
                name: 'companyDetail',
                component: () => import('../views/companyManage/companyDetail.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'userDetail',
                name: 'userDetail',
                component: () => import('../views/companyManage/userDetail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'userList',
                name: 'userList',
                component: () => import('../views/companyManage/userList.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'companyUserDetail',
                name: 'companyUserDetail',
                component: () => import('../views/companyManage/companyUserDetail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'companyUserList',
                name: 'companyUserList',
                component: () => import('../views/companyManage/companyUserList.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'Csearch',
                name: 'searchCompany',
                component: () => import('../views/companyManage/search.vue'),
                children: [
                    {
                        path: 'companyList',
                        name: 'companyList',
                        component: () => import('../views/companyManage/companyList.vue'),
                        meta: {
                            requireAuth: true,
                        }
                    }
                ]
            },
            {
                path: 'addRuleHPf',
                name: 'addRuleHPf',
                component: () => import('../views/companyManage/addRuleHPf.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'consumptionRule',
                name: 'consumptionRule',
                component: () => import('../views/companyManage/consumptionRule.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'poster',
                name: 'poster',
                component: () => import('../views/companyManage/poster.vue'),
                meta: {
                    requireAuth: true,
                }
            },
        ],
    },
    {
        path: '/userIndex',
        name: 'userIndex',
        component: () => import('../views/userManage/UserIndex.vue'),
        redirect: '/userIndex/userManageDetail',
        children: [
            {
                path: 'userManageDetail',
                name: 'userManageDetail',
                component: () => import('../views/userManage/detail.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'userRegisterPoster',
                name: 'userRegisterPoster',
                component: () => import('../views/userManage/userPoster.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'userEdit',
                name: 'userEdit',
                component: () => import('../views/userManage/edit.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            }
        ],
    },
    {
        path: '/mineIndex',
        name: 'mineIndex',
        component: () => import('../views/mine/MineIndex.vue'),
        redirect: '/mineIndex/accountSecurity',
        children: [
            {
                path: 'accountSecurity',
                name: 'accountSecurity',
                component: () => import('../views/mine/accountSecurity.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'setPwd',
                name: 'setPwd',
                component: () => import('../views/mine/setPwd.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'qyWechat',
                name: 'qyWechat',
                component: () => import('../views/mine/qyWechat/index.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
        ],
    },
    {
        path: '/comSalesIndex',
        name: 'comSalesIndex',
        component: () => import('../views/commercialSalesManage/ComSalesIndex.vue'),
        redirect: '/comSalesIndex/cShopList',
        children: [
            {
                path: 'cShopList',
                name: 'cShopList',
                component: () => import('../views/commercialSalesManage/shop/list.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'cShopDetail',
                name: 'cShopDetail',
                component: () => import('../views/commercialSalesManage/shop/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'cShopOrder/:type',
                name: 'cShopOrder',
                component: () => import('../views/commercialSalesManage/shop/order.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'cOrderList/:type',
                name: 'cOrderList',
                component: () => import('../views/commercialSalesManage/order/list.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true
                }
            },
            {
                path: 'cSellOrderList',
                name: 'cSellOrderList',
                component: () => import('../views/commercialSalesManage/order/sellList.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'cBusinessOrderList',
                name: 'cBusinessOrderList',
                component: () => import('../views/commercialSalesManage/order/businessList.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'cClientOrderList',
                name: 'cClientOrderList',
                component: () => import('../views/commercialSalesManage/order/clientList.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'cRetailOrderList',
                name: 'cRetailOrderList',
                component: () => import('../views/commercialSalesManage/order/retailList.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'cOrderDetail',
                name: 'cOrderDetail',
                component: () => import('../views/commercialSalesManage/order/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'cOrderCheck',
                name: 'cOrderCheck',
                component: () => import('../views/commercialSalesManage/order/orderCheck.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'cBacklogList',
                name: 'cBacklogList',
                component: () => import('../views/commercialSalesManage/backlog/list.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'cBacklogDetail',
                name: 'cBacklogDetail',
                component: () => import('../views/commercialSalesManage/backlog/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'cBacklogEdit',
                name: 'cBacklogEdit',
                component: () => import('../views/commercialSalesManage/backlog/edit.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'cPaymentList',
                name: 'cPaymentList',
                component: () => import('../views/commercialSalesManage/payment/list.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'cPaymentDetail',
                name: 'cPaymentDetail',
                component: () => import('../views/commercialSalesManage/payment/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
        ],
    },
    {
        path: '/resourceIndex',
        name: 'resourceIndex',
        component: () => import('../views/resourceManage/ResourceIndex.vue'),
        children: [
            {
                path: 'serviceIndex',
                name: 'serviceIndex',
                component: () => import('../views/resourceManage/serviceIndex.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'updateCustomer',
                name: 'updateCustomer',
                component: () => import('../views/resourceManage/updateCustomer.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'addCustomer',
                name: 'addCustomer',
                component: () => import('../views/resourceManage/addCustomer.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'rServiceDetail',
                name: 'rServiceDetail',
                component: () => import('../views/resourceManage/rService/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'rServiceAddRecord',
                name: 'rServiceAddRecord',
                component: () => import('../views/resourceManage/rService/addRecord.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'rServiceRecordList',
                name: 'rServiceRecordList',
                component: () => import('../views/resourceManage/rService/recordList.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'rServiceAddOrder',
                name: 'rServiceAddOrder',
                component: () => import('../views/resourceManage/rService/addOrder.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'allocationIndex',
                name: 'allocationIndex',
                component: () => import('../views/resourceManage/allocationIndex.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'rAllocationDetail',
                name: 'rAllocationDetail',
                component: () => import('../views/resourceManage/rAllocation/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'rAllocationCustomer',
                name: 'rAllocationCustomer',
                component: () => import('../views/resourceManage/rAllocation/customer.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'addressList',
                name: 'addressList',
                component: () => import('../views/resourceManage/rService/addressList.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'addressDetail',
                name: 'addressDetail',
                component: () => import('../views/resourceManage/rService/addressDetail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
                
            },
            {
                path: 'customerList',
                name: 'customerList',
                component: () => import('../views/resourceManage/rCustomer/list.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'customerDetail',
                name: 'customerDetail',
                component: () => import('../views/resourceManage/rCustomer/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            }
        ],
        meta: {
            requireAuth: true
        }
    },
    // 出库管理 start
    {
        path: '/outboundIndex',
        name: 'outboundIndex',
        component: () => import('../views/outboundManage/OutboundIndex.vue'),
        redirect: '/outboundIndex/outboundList',
        children: [
            {
                path: 'outboundList',
                name: 'outboundList',
                component: () => import('../views/outboundManage/list.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true
                }
            },
            {
                path: 'outboundDetail',
                name: 'outboundDetail',
                component: () => import('../views/outboundManage/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'outboundEdit',
                name: 'outboundEdit',
                component: () => import('../views/outboundManage/edit.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'outboundDistributionList',
                // path: 'outboundDistributionList/:wsid',
                name: 'outboundDistributionList',
                component: () => import('../views/outboundManage/distributionList.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'outboundDistribution',
                name: 'outboundDistribution',
                component: () => import('../views/outboundManage/distribution.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
        ]
    },
    // 出库管理 end
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            showNav: true
        }
    },
    {
        path: '/qyLogin/:id/:token',
        name: 'qyLogin',
        component: QyLogin,
        meta: {
            showNav: true
        }
    },
    {
        path: '/guide',
        name: 'guide',
        component: Guide,
        meta: {
            requireAuth: true,
            showNav: true
        }
    },
    {
        path: '/password',
        name: 'passwordFind',
        component: PasswordFind,
        meta: {
            showNav: true
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            showNav: true
        }
    },
    // 门店管理 start
    {
        path: '/ShopIndex',
        name: 'ShopIndex',
        component: () => import('../views/shopManage/ShopIndex.vue'),
        redirect: '/ShopIndex/shopIndex',
        children: [
            {
                path: 'shopIndex',
                name: 'shopIndex',
                component: () => import('../views/shopManage/index.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'shopDetail',
                name: 'shopDetail',
                component: () => import('../views/shopManage/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'addShop',
                name: 'addShop',
                component: () => import('../views/shopManage/addShop.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'shopBanner',
                name: 'shopBanner',
                component: () => import('../views/shopManage/banner.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'shopBannerDetail',
                name: 'shopBannerDetail',
                component: () => import('../views/shopManage/bannerDetail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'activityList',
                name: 'activityList',
                component: () => import('../views/shopManage/activityList.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'activityDetail',
                name: 'activityDetail',
                component: () => import('../views/shopManage/activityDetail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'activityRecord',
                name: 'activityRecord',
                component: () => import('../views/shopManage/activityRecord.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
        ],
    },
    // 门店管理 end
    // 内容管理 start
    {
        path: '/KnowledgeIndex',
        name: 'KnowledgeIndex',
        component: () => import('../views/knowledgeManage/KnowledgeIndex.vue'),
        redirect: '/KnowledgeIndex/kManageIndex',
        children: [
            {
                path: 'kManageIndex',
                name: 'kManageIndex',
                component: () => import('../views/knowledgeManage/index.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'kManageDetail',
                name: 'kManageDetail',
                component: () => import('../views/knowledgeManage/detail.vue'),
                meta: {
                    requireAuth: true,
                    showNav: true
                }
            },
            {
                path: 'kManageEdit',
                name: 'kManageEdit',
                redirect: '/commondityIndex/kManageEdit/kBaseinfo',
                component: () => import('../views/knowledgeManage/editKnowledge/KnowledgeEditIndex.vue'),
                children: [
                    {
                        path: 'kBaseinfo',
                        name: 'kBaseinfo',
                        component: () => import('../views/knowledgeManage/editKnowledge/baseInfo.vue'),
                        meta: {
                            requireAuth: true,
                            showNav: true
                        }
                    },
                    {
                        path: 'kDetail',
                        name: 'kDetail',
                        component: () => import('../views/knowledgeManage/editKnowledge/detail.vue'),
                        meta: {
                            requireAuth: true,
                            showNav: true
                        }
                    },
                    {
                        path: 'kBuyadd',
                        name: 'kBuyadd',
                        component: () => import('../views/knowledgeManage/editKnowledge/buyadd.vue'),
                        meta: {
                            requireAuth: true,
                            showNav: true
                        }
                    },
                    {
                        path: 'kVisitlist',
                        name: 'kVisitlist',
                        component: () => import('../views/knowledgeManage/editKnowledge/visitlist.vue'),
                        meta: {
                            requireAuth: true,
                            showNav: true
                        }
                    },
                    {
                        path: 'kVideoList',
                        name: 'kVideoList',
                        component: () => import('../views/knowledgeManage/editKnowledge/videoList.vue'),
                        meta: {
                            requireAuth: true,
                            showNav: true
                        }
                    },
                    {
                        path: 'kVideoDetail',
                        name: 'kVideoDetail',
                        component: () => import('../views/knowledgeManage/editKnowledge/videoDetail.vue'),
                        meta: {
                            requireAuth: true,
                            showNav: true
                        }
                    },
                    {
                        path: 'kTypeList',
                        name: 'kTypeList',
                        component: () => import('../views/knowledgeManage/editKnowledge/typeList.vue'),
                        meta: {
                            requireAuth: true,
                            showNav: true
                        }
                    },
                    {
                        path: 'kTypeDetail',
                        name: 'kTypeDetail',
                        component: () => import('../views/knowledgeManage/editKnowledge/typeDetail.vue'),
                        meta: {
                            requireAuth: true,
                            showNav: true
                        }
                    },
                ]
            },
        ],
    },
    // 内容管理 end
]

// 
const router = new VueRouter({
    // mode: 'hash',
    routes,
    scrollBehavior() {
        // to, from, savedPosition
        return { x: 0, y: 0 }
    }
})

// 设置访问环境
if (/wxwork/.test(navigator.userAgent.toLowerCase())) {
    // 在企业微信中打开
    store.commit("setUserAgent", 'qyWechat');
} else {
    // 非企业微信环境中打开
    store.commit("setUserAgent", 'other');
}

// 设置路由守卫，在进页面之前，判断有token，才进入页面，否则返回登录页面
// if (storage.get("USERINFO") && storage.get("OPENID") && storage.get("QYUSERINFOID")) {
//     store.commit("updateUserInfo", storage.get("USERINFO"));
//     store.commit("updateOpenid", storage.get("OPENID"));
//     store.commit("setMenuList", storage.get("MENULIST"));
//     store.commit("setQyUserId", storage.get("QYUSERINFOID"));
// }


// 用户登录形式，默认为网页0
let userLoginType = store.state.userLoginType

router.beforeEach((to, from, next) => {
    //根据字段判断是否路由过滤
    let OPENID = storage.get('OPENID') ? storage.get('OPENID') : '';
    let USERINFO = storage.get('USERINFO');
    if (to.meta.requireAuth) {
        if (to.name === 'login') {
            // 如果当前路由是登录页
            if (OPENID != '' && USERINFO != null && USERINFO.mobile != null) {
                // 已登录，跳转到 home.vue
                next({ path: '/home' });
            } else {
                // 未登录，继续访问登录页
                next();
            }
        } else if (to.name === 'qyLogin') {
            // 如果当前路由是一键登录
            if (OPENID != '' && USERINFO != null) {
                if (USERINFO.mobile != null) {
                    // 已登录且有手机号，跳转到 home.vue
                    next({ path: '/home' });
                } else {
                    // 已登录但没有手机号，跳转到 guide.vue
                    next({ path: '/guide' });
                }
            } else {
                // 未登录，继续访问一键登录页
                next();
            }
        } else if (to.name === 'guide') {
            // 如果当前路由是导航页
            if (OPENID != '' && OPENID != null) {
                if (USERINFO.mobile != null) {
                    // 已登录且有手机号，跳转到 home.vue
                    next({ path: '/home' });
                } else {
                    // 未登录，继续访问一键登录页
                    next();
                }
            } else {
                // 未登录，继续访问导航页
                next({ path: '/qyLogin/${userid}/${token}' });
            }
        } else {
            // 其他页面根据实际情况进行判断
            if (OPENID != '' && USERINFO != null && USERINFO.mobile != null) {
                // 已登录，放行
                next();
            } else {
                // 未登录，跳转到登录页面
                next({ path: '/login' });
            }
        }
    } else {

        if (to.name === 'login') {
            if (OPENID != '' && USERINFO != null && USERINFO.mobile != null && userLoginType == 0) {
                // 已登录，跳转到 home.vue
                next({ path: '/home' });
            } else {
                // 不需要认证的页面，直接放行
                next();
            }
        } else if (to.name === 'qyLogin') {
            // 如果当前路由是一键登录
            if (OPENID != '' && USERINFO != null && userLoginType == 1) {
                if (USERINFO.mobile != null) {
                    // 已登录且有手机号，跳转到 home.vue
                    next({ path: '/home' });
                } else {
                    // 已登录但没有手机号，跳转到 guide.vue
                    next({ path: '/guide' });
                }
            } else {
                // 未登录，继续访问一键登录页
                next();
            }
        } else {
            // 不需要认证的页面，直接放行
            next();
        }
    }
});


// 将router对象传入到Vue实例中
export default router